
import { AuthenticationMixin } from "@/store/mixins";
import { mixins, Options } from "vue-class-component";
import dayjs from "dayjs";

@Options({})
export default class Infobar extends mixins(AuthenticationMixin) {
  stepNumbers: number[] = [1, 2, 3, 4];

  get lockedDate(): string {
    return dayjs(this.userOrganization.lockedDate).format("DD-MM-YYYY");
  }

  selectStep(selectedStep: number) {
    for (const stepNumber of this.stepNumbers) {
      const stepButton = document.getElementById("btn-" + stepNumber)!;
      stepButton.classList.remove("btn-primary");
      if (!stepButton.classList.contains("btn-outline-primary")) {
        stepButton.classList.add("btn-outline-primary");

        const stepContent = document.getElementById("step-" + stepNumber)!;
        if (!stepContent.classList.contains("hide")) {
          stepContent.classList.add("hide");
        }
      }
    }
    const stepButton = document.getElementById("btn-" + selectedStep)!;
    if (!stepButton.classList.contains("btn-primary")) {
      stepButton.classList.add("btn-primary");
      stepButton.classList.remove("btn-outline-primary");
    }
    const stepContent = document.getElementById("step-" + selectedStep)!;
    stepContent.classList.remove("hide");
  }
}
